<template>
  <img :src="imageUrl" :alt="altText" class="top-brand-icon" />
</template>

<script>
export default {
  props: {
    imageUrl: {
      type: String,
      required: true
    },
    altText: {
      type: String,
      required: false,
      default: 'brand-icon'
    }
  }
}
</script>

<style lang="scss" scoped>
.top-brand-icon {
  @extend %hover-common;
  box-sizing: border-box;
  height: 100px;
  width: 100px;
  border: 1px solid $gray-2;
  border-radius: 8px;
}
</style>
